<template>
  <div>
    <b-modal
      id="link"
      title="VINCULAR PRODUTO"
      hide-footer
      no-close-on-backdrop
      size="lg"
    >
      <div class="row">
        <div class="col-md-12">
          <input
            type="text"
            class="form-control"
            v-model="search"
            @input="listProducts"
          />
        </div>
        <div class="col-md-12" style="height: 400px; overflow-y: scroll">
          <div v-for="(item, key) in products" :key="key" class="pt-1 pb-1">
            <div class="row m-0 v-clean">
              <div class="col-md-8">
                <h6 class="mb-0">
                  NOME:
                  {{ item.name }}
                </h6>
                <div class="mb-0">
                  UNIDADE DE MEDIDA:
                  {{ item.unit_of_measurement_name }}
                </div>
                <div class="mb-0">
                  TIPO:
                  {{ item.type == "PADRAO" ? "PADRÃO" : "EMPRESA" }}
                </div>
              </div>
              <div
                class="col-md-4 d-flex align-items-center jutify-content-center"
              >
                <v-btn class="btn-edit" @click="selectItem(item)"
                  ><i class="fas fa-check mr-2"></i>SELECIONAR</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col class="pt-0 pb-0">
          <label-required-field label="NOME" />
          <b-input :disabled="isSelectedtItem" ref="autofocus" v-model="name" />
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <LabelRequiredField label="UNIDADE DE MEDIDA" />
          <select
            :disabled="isSelectedtItem"
            v-model="unit_of_measurement_id"
            class="form-control"
            @change="handleChangeUnitOfMeasurementId($event.target.value)"
          >
            <option value="">SELECIONE...</option>
            <option
              v-for="unit in product_units_of_measurement"
              :key="unit.id"
              :value="unit.id"
            >
              {{ `${unit.name} (${unit.abbreviation})` }}
            </option>
          </select>
        </div>
      </div>
      <b-row>
        <b-col class="pt-0 pb-0">
          <label-required-field label="CATEGORIA" />
          <b-select
            :options="categories"
            text-field="name"
            value-field="id"
            v-model="stock_item_category_id"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="pt-0">
          <label-required-field label="TAMANHO" />
          <b-input v-model.number="size"></b-input>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn-cancel @click="$bvModal.hide('new_product')" />
        </b-col>
        <b-col cols="auto">
          <v-btn-save :disabled="loading" :loading="loading" type="submit" />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import toast from "../../../lib/ToastNotification";
import api from "../../../services/api";
import ErrorsMessages from "../ErrorsMessages.vue";
import LabelRequiredField from "../LabelRequiredField.vue";
import VBtnCancel from "../VBtnCancel.vue";
import VBtnSave from "../VBtnSave.vue";

export default {
  name: "NewProduct",

  components: {
    VBtnSave,
    VBtnCancel,
    LabelRequiredField,
    ErrorsMessages,
  },

  props: {
    defaultName: { type: String, default: "" },
    stock_item_categories: Array,
    stock_item_units_of_measurement: Array,
    product_units_of_measurement: Array,
  },

  data() {
    return {
      search: "",

      errors: [],
      loading: false,
      loadingProducts: false,

      isSelectedtItem: false,
      selectedtItem: false,

      products: [],

      unit_of_measurement_id: "",
      name: "",
      stock_item_category_id: "",
      stock_item_unit_of_measurement_id: "",
      size: "",
    };
  },

  created() {
    this.isSelectedtItem = false;
    this.selectedtItem = false;

    this.listProducts();
    this.evOnShow();
    this.evOnShown();
  },

  computed: {
    categories() {
      return [{ id: "", name: "SELECIONE" }, ...this.stock_item_categories];
    },

    unitsOfMeasurement() {
      return [
        { id: "", name: "SELECIONE" },
        ...this.stock_item_units_of_measurement,
      ];
    },
  },

  methods: {
    handleChangeUnitOfMeasurementId(id) {
      if (id) {
        let { product_units_of_measurement, unitsOfMeasurement } = this;

        let unit = product_units_of_measurement.find((item) => item.id == id);

        if (unit) {
          let unit_of_measurement = unitsOfMeasurement.find(
            ({ value }) => unit.value == value
          );

          if (unit_of_measurement) {
            this.stock_item_unit_of_measurement_id = unit_of_measurement.id;
          }
        }
      }
    },

    selectItem(item) {
      this.isSelectedtItem = true;
      this.selectedtItem = item;

      let { unitsOfMeasurement } = this;

      this.name = item.name;
      this.unit_of_measurement_id = item.unit_of_measurement_id;

      let unit_of_measurement = unitsOfMeasurement.find(
        ({ abbreviation }) =>
          item.unit_of_measurement_abbreviation == abbreviation
      );

      if (unit_of_measurement) {
        this.stock_item_unit_of_measurement_id = unit_of_measurement.id;
      }

      this.$bvModal.hide("link");
    },

    async listProducts() {
      try {
        this.loadingProducts = true;

        const params = { search: this.search };

        const response = await api.get(
          "/rest-home/product/list-not-linked-stock-item",
          {
            params,
          }
        );

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.products = data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingProducts = false;
      }
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.stock_item_category_id = "";
      this.stock_item_unit_of_measurement_id = "";
      this.name = this.defaultName;
      this.size = "";
    },

    async evOnShown() {
      setTimeout(() => this.$refs.autofocus.focus(), 200);
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let {
          name,
          unit_of_measurement_id,
          stock_item_unit_of_measurement_id,
          stock_item_category_id,
          size,
          selectedtItem,
        } = this;

        const params = {
          name,
          unit_of_measurement_id,
          stock_item_unit_of_measurement_id,
          stock_item_category_id,
          size,
          selectedtItem,
        };

        const response = await api.post(
          "/rest-home/stock/items/product",
          params
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$bvModal.hide("new_product");
          toast(message, "success");
          this.$emit("created");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>